/* Beauty Queens – colour & length switching on collection cards (.bqc-card) */
(() => {
  const data = new WeakMap();

  function stateOf(box) {
    if (!data.has(box)) {
      let variants = [];
      try { variants = JSON.parse(box.querySelector('[data-bqc-variants]').textContent); } catch (e) {}
      const idx = (k) => (box.dataset[k] === '' || box.dataset[k] == null ? null : Number(box.dataset[k]));
      const active = (sel, attr) => box.querySelector(sel + '.is-active')?.getAttribute(attr) ?? null;
      data.set(box, {
        variants,
        ci: idx('colorIndex'),
        li: idx('lengthIndex'),
        color: active('.bqc-swatch', 'data-bqc-color'),
        length: active('.bqc-length', 'data-bqc-length'),
      });
    }
    return data.get(box);
  }

  // Best variant for the chosen colour/length: exact + in stock > exact > same colour in stock > same colour
  function pick(s) {
    const okC = (v) => s.ci === null || s.color === null || v.o[s.ci] === s.color;
    const okL = (v) => s.li === null || s.length === null || v.o[s.li] === s.length;
    return s.variants.find((v) => okC(v) && okL(v) && v.a)
      || s.variants.find((v) => okC(v) && okL(v))
      || s.variants.find((v) => okC(v) && v.a)
      || s.variants.find(okC);
  }

  function setImage(card, src) {
    const img = card.querySelector('.bqc-card__img--front');
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.src = src;
    card.classList.add('bqc-card--no-flip'); // hovering the card would otherwise show the 2nd photo
  }

  function render(box) {
    const s = stateOf(box);
    const card = box.closest('.bqc-card');
    const v = pick(s);
    if (!card || !v) return;

    // sync the selection with the variant actually shown
    if (s.ci !== null) s.color = v.o[s.ci];
    if (s.li !== null) s.length = v.o[s.li];

    if (v.img) { setImage(card, v.img); card.dataset.bqcImg = v.img; }

    // price + badge
    const sale = card.querySelector('.bqc-card__price-sale');
    const was = card.querySelector('.bqc-card__price-was');
    if (sale) sale.textContent = v.p;
    if (was) { was.textContent = v.c || ''; was.hidden = !v.c; }
    const badge = card.querySelector('.bqc-card__off-badge');
    if (badge) { badge.textContent = v.off > 0 ? v.off + '% OFF' : ''; badge.hidden = !(v.off > 0); }
    card.classList.toggle('bqc-card--soldout', !v.a);

    // links open the product with this variant selected
    const url = box.dataset.url + '?variant=' + v.id;
    card.querySelectorAll('a[href^="' + box.dataset.url + '"]').forEach((a) => { a.href = url; });

    // quick view / quick select buttons
    card.querySelectorAll('.bqc-qv-trigger, .bqc-quick-select').forEach((b) => {
      b.dataset.variantId && (b.dataset.variantId = v.id);
      b.dataset.qvVariantId = v.id;
      b.dataset.qvPrice = v.p;
      if (v.c) b.dataset.qvCompare = v.c;
      b.dataset.qvHasCompare = String(!!v.c);
      b.dataset.qvAvailable = String(v.a);
      if (v.img) b.dataset.qvImage = v.img.replace('width=700', 'width=900');
    });

    // active states
    const label = box.querySelector('[data-bqc-color-label]');
    if (label && s.color !== null) label.textContent = s.color;
    box.querySelectorAll('.bqc-swatch').forEach((b) => {
      const on = b.dataset.bqcColor === s.color;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
    box.querySelectorAll('.bqc-length').forEach((b) => {
      const len = b.dataset.bqcLength;
      const on = len === s.length;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
      const exists = s.variants.some((x) => x.o[s.li] === len && (s.ci === null || s.color === null || x.o[s.ci] === s.color));
      const inStock = s.variants.some((x) => x.a && x.o[s.li] === len && (s.ci === null || s.color === null || x.o[s.ci] === s.color));
      b.classList.toggle('is-unavailable', !inStock);
      b.hidden = !exists;
    });
  }

  document.addEventListener('click', (e) => {
    const box = e.target.closest('[data-bqc-swatches]');
    if (!box) return;
    const s = stateOf(box);
    const colorBtn = e.target.closest('[data-bqc-color]');
    const lengthBtn = e.target.closest('[data-bqc-length]');
    const moreBtn = e.target.closest('[data-bqc-more]');
    if (colorBtn) { s.color = colorBtn.dataset.bqcColor; render(box); }
    else if (lengthBtn) { s.length = lengthBtn.dataset.bqcLength; render(box); }
    else if (moreBtn) { box.classList.add('is-expanded'); moreBtn.remove(); }
    else return;
    e.preventDefault();
  });

  // Desktop: hovering a swatch previews its photo
  document.addEventListener('mouseover', (e) => {
    const btn = e.target.closest('[data-bqc-color]');
    if (!btn) return;
    const box = btn.closest('[data-bqc-swatches]');
    const s = stateOf(box);
    const card = box.closest('.bqc-card');
    const v = s.variants.find((x) => x.o[s.ci] === btn.dataset.bqcColor && x.img);
    if (!card || !v) return;
    if (card.dataset.bqcImg === undefined) {
      card.dataset.bqcImg = card.querySelector('.bqc-card__img--front')?.getAttribute('src') || '';
    }
    setImage(card, v.img);
  });
  document.addEventListener('mouseout', (e) => {
    const btn = e.target.closest('[data-bqc-color]');
    if (!btn || btn.contains(e.relatedTarget)) return;
    const card = btn.closest('.bqc-card');
    if (card && card.dataset.bqcImg) setImage(card, card.dataset.bqcImg);
  });

  // Set up length availability for cards on load and after the grid is re-rendered (filters, load more)
  const init = (root) => root.querySelectorAll('[data-bqc-swatches]:not([data-bqc-ready])').forEach((box) => {
    box.dataset.bqcReady = '';
    if (box.querySelector('.bqc-length')) {
      const s = stateOf(box);
      s.variants.length && s.li !== null && box.querySelectorAll('.bqc-length').forEach((b) => {
        const inStock = s.variants.some((x) => x.a && x.o[s.li] === b.dataset.bqcLength && (s.ci === null || s.color === null || x.o[s.ci] === s.color));
        b.classList.toggle('is-unavailable', !inStock);
      });
    }
  });
  init(document);
  new MutationObserver(() => init(document)).observe(document.body, { childList: true, subtree: true });
})();